import { Injectable, NgZone } from '@angular/core';
import { isFunction } from '../utils/is-function';
import { isObject } from '../utils/is-object';

@Injectable()
export class ExtensionsService {
    constructor(private _ngZone: NgZone) {}
}
/**
 * @param resolveObj - object, with members of type function / promise / plain object
 * @returns {Promise<T>} - object with results of functions/promises merged with plain object members of resolveObj
 */
export function promiseUnwrap<T>(resolveObj) {
    const promise = new Promise<T>((resolve, reject) => {
        let result: T = <any>{};

        const promisesArray: Promise<any>[] = [];

        if (resolveObj instanceof Promise) {
            // promise
            promisesArray.push(resolveObj);
            resolveObj.then((v) => (result = v));
        } else {
            Object.keys(resolveObj || {}).forEach((key) => {
                var item = resolveObj[key];
                if (isFunction(item)) {
                    // function or promise
                    var fnRes = item();
                    if (fnRes instanceof Promise) {
                        // promise
                        promisesArray.push(fnRes);
                        fnRes.then((v) => (result[key] = v));
                    } else {
                        // function
                        result[key] = fnRes;
                    }
                } else {
                    // nor function nor promise
                    result[key] = item;
                }
            });
        }

        if (promisesArray.length) {
            Promise.all(promisesArray).then(() => resolve(result), reject);
        } else {
            resolve(result);
        }
    });

    return promise;
}

export function IsJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }

    return true;
}

export function GetPropertyByString(obj: { [prop: string]: any }, propertyString) {
    if (!propertyString) return undefined;

    var prop,
        props = propertyString.split('.');

    for (var i = 0; i < props.length - 1; i++) {
        prop = props[i];

        var candidate = obj[prop];
        if (candidate !== undefined) {
            obj = candidate;
        } else {
            break;
        }
    }
    return obj[props[i]];
}

/******************************************
 String manipulations
 ******************************************/
declare global {
    interface StringConstructor {
        format(pattern: string, ...args: any[]): string;
    }
}
String.format = function () {
    var s = arguments[0];
    for (var i = 0; i < arguments.length - 1; i++) {
        var reg = new RegExp('\\{' + i + '\\}', 'gm');
        s = s.replace(reg, arguments[i + 1]);
    }

    return s;
};
/******************************************
 Check mobile operating system
 ******************************************/
declare global {
    interface Window {
        opera;
        html2canvas;
    }
}

declare global {
    interface String {
        format: Function;
        paddingLeft(paddingValue: string): string;
    }
}

String.prototype.paddingLeft = function (paddingValue) {
    return String(paddingValue + this).slice(-paddingValue.length);
};

export function windowOpenCentered(url, popupWidth, popupHeight) {
    const screenWidth = window.innerWidth || document.documentElement.clientWidth || screen.width,
        screenHeight = window.innerHeight || document.documentElement.clientHeight || screen.height,
        left = screenWidth / 2 - popupWidth / 2 + window.screenLeft,
        top = screenHeight / 2 - popupHeight / 2 + window.screenTop;
    return window.open(
        url,
        '_blank',
        'width=' + popupWidth + ', height=' + popupHeight + ', top=' + top + ', left=' + left,
    );
}

if (typeof String.prototype.format != 'function') {
    String.prototype.format = function (val) {
        var s = this.toString();
        if (isObject(val)) {
            var keys = Object.keys(val);
            for (var k = 0; k < keys.length; k++) {
                s = s.replace(keys[k], val[keys[k]]);
            }
        } else {
            for (var i = 0; i < arguments.length; i++) {
                var reg = new RegExp('\\{' + i + '\\}', 'gm');
                s = s.replace(reg, arguments[i]);
            }
        }
        return s;
    };
}

if (typeof String.prototype.startsWith != 'function') {
    String.prototype.startsWith = function (str) {
        return this.slice(0, str.length) == str;
    };
}

if (typeof String.prototype.endsWith != 'function') {
    String.prototype.endsWith = function (str) {
        return this.slice(-str.length) == str;
    };
}
